module.exports = __webpack_public_path__ + "static/1-631d6e4bfaed395c26856ed30cad8c7b.png";